import { Hero } from "@/sections/Hero";
import { CategoryCards } from "@/sections/CategoryCards";
import { FeaturedProducts } from "@/sections/FeaturedProducts";
import { TrustIcons } from "@/sections/TrustIcons";
import { About } from "@/sections/About";
import { WhyZebaa } from "@/sections/WhyZebaa";
import { StatsBanner } from "@/sections/StatsBanner";
import { BrandStatement } from "@/sections/BrandStatement";
import { LocalSeoSection, LOCAL_FAQS } from "@/components/LocalSeoSection";
import { HiddenSeo } from "@/components/HiddenSeo";
import { MarqueeBar } from "@/components/MarqueeBar";
import { Seo } from "@/components/Seo";
import { localBusinessSchema, websiteSchema, faqSchema } from "@/lib/seo";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo
        path="/"
        jsonLd={[localBusinessSchema(), websiteSchema(), faqSchema(LOCAL_FAQS)]}
      />
      <HiddenSeo />
      <Hero />
      <MarqueeBar />
      <FeaturedProducts />
      <CategoryCards />
      <BrandStatement />
      <WhyZebaa />
      <StatsBanner />
      <LocalSeoSection />
      <TrustIcons />
    </div>
  );
}
